// IMAGE SLOTS (Kampsport Kids Ready Norge, Norwegian copy of Martial Arts Kids Class Ready)
// Hosted in the Impultienda store resources (Recursos) of the Norwegian store.
const STORE = '54130539-3190-4af0-97a9-c7fac204c883';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Norwegian Gamma Studio cover plus
 * real pages on the iMac, and the bonus photos with their Norwegian titles typed in. Pure white background.
 */
const IMAC = RES + '1793030345608_no-mockup-imac.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/**
 * Real pages of the Norwegian Gamma Studio book (9:16), same order as lookInside.captions: p.6, 20, 12, 13, 35, 39.
 * Only pages that passed the page-by-page check of the Norwegian book (producto-studio/qc.md).
 */
export const pageImages: string[] = [
  RES + '1793030624080_no-pagina-06.webp',
  RES + '1793030625490_no-pagina-20.webp',
  RES + '1793030626552_no-pagina-12.webp',
  RES + '1793030627658_no-pagina-13.webp',
  RES + '1793031035831_no-pagina-35.webp',
  RES + '1793030630467_no-pagina-39.webp',
];
/** 5 bonus covers (Norwegian titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1793030346805_no-bono-juegos.webp',
  RES + '1793030347502_no-bono-cinturon.webp',
  RES + '1793030348328_no-bono-padres.webp',
  RES + '1793030348971_no-bono-pads.webp',
  RES + '1793030349641_no-bono-prueba.webp',
];
